import { EventEmitter, OnChanges, Output } from "@angular/core";
import { Component, OnInit, Input } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { GPAdjustmentRequestDto } from "../../../../core/models/bcLedgers/gpAdjustmentRequestDto";
import { GPAdjustmentData } from "../../../../core/models/bcLedgers/gpAdjustmentResponseDto";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { Table, TableModule } from "primeng/table";
import { CommonModule } from "@angular/common";
import { BcLedgerStacker } from "../../../../core/models/bcLedgers/bcLedgerStacker";
import { LoaderService } from "../../../../core/services/loader.service";
import { exportExcel } from "../../../../core/services/shared.service";
import { HidedynamicsdatePipe } from "../../../../shared/pipes/hidedate/hidedynamicsdate.pipe";
import { BcledgerService } from "../../../../core/services/bcledger.service";

import { InputTextModule } from "primeng/inputtext";
import { DropdownModule } from "primeng/dropdown";
import { ButtonModule } from "primeng/button";

@Component({
  selector: "jni-gp-adjustment",
  templateUrl: "./gp-adjustment.component.html",
  styleUrls: ["./gp-adjustment.component.scss"],
  imports: [
    TableModule,
    CommonModule,
    HidedynamicsdatePipe,
    InputTextModule,
    DropdownModule,
    ButtonModule,
  ],
})
export class GpAdjustmentComponent implements OnInit, OnChanges {
  @Input() bcLedgerStacker!: BcLedgerStacker;
  gpAdjustmentLists: GPAdjustmentData[] = [];
  gpAdjustmentsParams!: GPAdjustmentRequestDto;
  total!: number;
  fileName = "GPAdjustment";
  @Output() closeModalEvent = new EventEmitter();

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _gpAdjustmentService: BcledgerService,
    private _toastrService: JniToastrService,
    private _loaderService: LoaderService
  ) {
    this._activatedRoute.params.subscribe(params => {
      this.gpAdjustmentsParams = { ...params } as GPAdjustmentRequestDto;
    });
  }

  ngOnInit(): void {
    this.getGPAdjustments(this.gpAdjustmentsParams);
  }

  getGPAdjustments(payload: GPAdjustmentRequestDto) {
    this._loaderService.setLoaderState(true);
    this._gpAdjustmentService.gpAdjustments(payload).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res.data) {
          this.gpAdjustmentLists = res.data.Data ?? [];
          this.total = res.data.Total;
          return;
        }
        this._toastrService.error(
          res.message || "GP Adjustments Fetched",
          "GP Adjustments"
        );
      },
      error: () => {
        this._loaderService.setLoaderState(false);
        this._toastrService.error("No results found", "Error");
      },
    });
  }

  clearTable(table: Table) {
    table.clear();
  }

  exportExcelFile() {
    exportExcel(this.gpAdjustmentLists, this.fileName);
  }

  ngOnChanges() {
    if (this.bcLedgerStacker) {
      this.gpAdjustmentsParams = { ...this.bcLedgerStacker };
    }
  }

  onCloseModalEvent() {
    this.closeModalEvent.emit();
  }
}
